// extracted by mini-css-extract-plugin
module.exports = {"text":"EABD2HomeCardFront_text__1kSlr"};